import React, {useEffect, useState} from 'react'
import * as THREE from "three"
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader"
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls"
import { URL } from "../../config"

const View3d = ({file, loadingLabel}) => {
  const [fileLoaded, setFileLoaded] = useState(false)
  const [percentageLoaded, setPercentageLoaded] = useState(0)
  const [isFullscreen, setIsFullscreen] = useState(false)

  useEffect(() => {
    var scene = new THREE.Scene()
    var camera = new THREE.PerspectiveCamera( 48, window.innerWidth / window.innerHeight, 0.1, 1000 )
    camera.position.set(-10, 4, 15)
    scene.background = new THREE.Color('black')

    var renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true
    })
    renderer.setPixelRatio(2)
    renderer.setSize(360, 180)
    camera.aspect = 360 / 180


    var controls = new OrbitControls(camera, renderer.domElement)
    controls.addEventListener("change", render)
    controls.enableDamping = true
    controls.dampingFactor = 0.8
    controls.update()

    // LIGHTS

    var aimingLight = new THREE.DirectionalLight(0xfaf1e6, 0.5)
    aimingLight.lookAt(new THREE.Vector3(0,0,0))
    scene.add(aimingLight)

    var hemiLight = new THREE.HemisphereLight( 0xffffff, 0xffffff, 0.1 )
    hemiLight.color.setRGB( 12, 12, 12 )
    hemiLight.groundColor.setRGB( 3, 3, 3 )
    hemiLight.position.set( 0, 500, 0 )
    scene.add( hemiLight )

    // LOAD THE FILE

    var loader = new GLTFLoader()

    loader.load(
      URL + file.url,
      function ( gltf ) {
        setFileLoaded(true)
        scene.add(gltf.scene)
        render()
      },

      // called while loading is progressing
      function ( xhr ) {
        setPercentageLoaded( xhr.loaded / xhr.total * 100 )
      },

      // called when loading has errors
      function ( error ) {
        console.log( 'An error happened', error )
      }
    )

    function render() {
      const {x, y, z} = camera.position
      aimingLight.position.set(x, y, z)
      renderer.render(scene, camera)
    }

    function activateFullscreen(e) {
      e.stopPropagation()
      document.getElementById("3d-view-close").style.display = "inline"
      document.getElementById("3d-view-open").style.display = "none"
      setIsFullscreen(true)

      renderer.setSize(window.innerWidth, window.innerHeight)
      camera.aspect = window.innerWidth / window.innerHeight
      camera.updateProjectionMatrix()
      controls.update()
      render()
    }

    function unsetFullscreen(e) {
      e.stopPropagation()
      document.getElementById("3d-view-close").style.display = "none"
      document.getElementById("3d-view-open").style.display = "inline"
      setIsFullscreen(false)

      renderer.setSize(360, 180)
      camera.aspect = 360 / 180
      camera.updateProjectionMatrix()
      controls.update()
      render()
    }

    let el = document.getElementById('threejs-root')

    let btnOpen = document.createElement('button')
    btnOpen.innerHTML = 'open'
    btnOpen.addEventListener('click', activateFullscreen, false)
    btnOpen.setAttribute("id", "3d-view-open")

    let btnClose = document.createElement('button')
    btnClose.innerHTML = 'close'
    btnClose.addEventListener('click', unsetFullscreen, false)
    btnClose.setAttribute("id", "3d-view-close")
    btnClose.style.display = "none"

    el.appendChild(btnOpen)
    el.appendChild(btnClose)
    el.appendChild(renderer.domElement)
  }, [])
  
  return <div>
    { !fileLoaded && <div>{loadingLabel || 'loading'}.. {Math.round(percentageLoaded)}%</div> }
    <div
      id="threejs-root"
      style={{
        display: fileLoaded ? "block" : "none",
        position: isFullscreen ? "fixed" : "inherit",
        top: isFullscreen ? 0 : "inherit",
        left: isFullscreen ? 0 : "inherit",
        zIndex: isFullscreen ? 200 : "inherit",
        backgroundColor: "black",
        overflow: "hidden"
      }}
    ></div>
  </div>
}

export default View3d